const config = {
  ENVIRONMENT_NAME: 'testing',
  forwoodId: {
    URL: 'https://id.testing.platform.forwoodsafety.com',
    USER_TOKEN_URL: 'https://lduzcwfzrd.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://5efx2zmaw4.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.testing.platform.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.testing.platform.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.testing.platform.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.platform.forwoodsafety.com',
    WEBSOCKET: 'wss://0bmk6ppdq1.execute-api.us-west-2.amazonaws.com/testing'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
